import PAGE_TYPES from 'bundles/unified-description-page-common/constants/pageTypes';

import guidedProjectInstructionsBackgroundImage from 'images/unified-description-page/guided-project-instructions-module-background.png';
import projectInstructionsBackgroundImage from 'images/unified-description-page/project-instructions-module-background.png';

const getProjectInstructionsBackgroundImage = (pageType?: typeof PAGE_TYPES[keyof typeof PAGE_TYPES]) => {
  switch (pageType) {
    case PAGE_TYPES.GUIDED_PROJECT:
      return guidedProjectInstructionsBackgroundImage;
    case PAGE_TYPES.PROJECT:
      return projectInstructionsBackgroundImage;
    default:
      return null;
  }
};

export default getProjectInstructionsBackgroundImage;
